import { render, staticRenderFns } from "./SioReports.vue?vue&type=template&id=4e663e17&"
import script from "./SioReports.vue?vue&type=script&lang=js&"
export * from "./SioReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports